module.exports = __webpack_public_path__ + "static/media/income-contribution-amount.37a1fe42.svg";